<script>
export default {
  page: {
    title: 'Terms',
    meta: [{ name: 'description', content: 'The Terms page.' }],
  },
}
</script>

<template>
  <v-container :class="$style.termsPageContainer" fluid>
    <h3 :class="$style.pageHeading">HealthBook+ Terms of Service</h3>
    <p>Dated: 11/24/2025</p>
    <v-row>
      <v-col cols="12" :class="$style.pageText">
        <p>
          These Terms of Service (these "Terms") set forth the terms and
          conditions upon which HealthBookPlus Holdings, Inc. ("our" "we" or
          "HealthBook+") offers you ("you" "your" or "EndUser") access to use
          HealthBook+’s personal health record and health hub application
          located at
          <a href="https://www.healthbookplus.com">www.myhealthbookplus.com</a>
          including any successor site or mobile application and all third-party
          software imbedded therein or accessed thereby (the "Application"). By
          clicking "I Agree", by accessing the Application, or otherwise
          indicating your assent, you agree to be bound by these Terms.
          Additionally, by accessing the Application, you agree to be bound by
          HealthBook+’s Privacy Policy, and all applicable laws. In the event of
          an inconsistency between these Terms and the Privacy Policy, these
          Terms shall control. Any reference to the singular in these Terms
          includes the plural and vice versa and reference to a gender includes
          the other gender unless the context requires otherwise. Any reference
          to a "person" in these Terms includes any individual, firm,
          unincorporated association or body corporate.
          <strong>
            IF YOU DO NOT AGREE TO THESE TERMS, DO NOT ACCESS OR USE
            APPLICATION. THIS IS A LEGALLY ENFORCEABLE CONTRACT. IF YOU ARE
            ACCESSING OR USING APPLICATION AND SERVICE ON BEHALF OF ANOTHER
            INDIVIDUAL YOU REPRESENT AND WARRANT THAT YOU HAVE ALL THE POWER AND
            AUTHORITY TO ENTER INTO THESE TERMS ON BEHALF OF THAT INDIVIDUAL AND
            TO PROVIDE HEALTHBOOK+ WITH ALL INFORMATION ABOUT THAT INDIVIDUAL
            THAT YOU MAY PROVIDE.
          </strong>
        </p>

        <p>
          HealthBook+ may modify these Terms upon providing written notice to
          you either via the e-mail registered under your account or by posting
          such changes through the Application. Any use of the Application
          following any such modification constitutes an acceptance of the
          modification. If you do not accept any modification, you must
          immediately cease all usage of the Application.
        </p>

        <p>
          The Application is a personal health and wellness information
          retrieval and management service that allows individuals to
          consolidate certain health and wellness information ("Health
          Information") through the Application and share information with
          others (including family members, doctors and other third-party
          providers). The Application is provided to you by HealthBook+ as an
          aid to assist you in organizing and managing Health Information (the
          “Services”).
        </p>
        <br />
        <div :class="[$style.customOrderList]">
          <ol type="1">
            <li :class="[$style.listHeading]">
              <h5>
                <strong>Your Use of the Application</strong>
              </h5>
              <ol type="1">
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong> Limited License to Use the Application </strong>
                  </span>
                  <p>
                    Subject to your compliance with these Terms, HealthBook+
                    hereby grants to you a limited, personal, non-exclusive,
                    non-transferable, license to access the Application solely
                    for your own personal purposes. Except for the licenses and
                    rights expressly granted under these Terms, no licenses or
                    rights are granted by HealthBook+ to you hereunder, by
                    implication, estoppel or otherwise. All such other licenses
                    and rights are reserved unto HealthBook+. Your right to
                    access and use the Application is personal to you and is not
                    transferable by you to any other person or entity. You are
                    only entitled to access and use the Application for lawful
                    purposes.
                  </p>

                  <p>
                    Your use of the Application may also be subject to
                    additional terms between you and another entity, such as a
                    healthcare provider or health plan. In addition to any
                    restrictions in these Terms, you shall not use the
                    Application in violation of any other terms applicable to
                    the Application to which you have agreed.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading"
                    ><strong>License Restrictions</strong>
                  </span>
                  <p>
                    You shall not take any of the following actions with respect
                    to Application nor will you use our Application to upload,
                    post, e-mail, distribute, transmit, link, solicit or
                    otherwise make available any content or use the Application
                    in any manner that:
                  </p>
                  <ul>
                    <li class="mt-2">
                      uploads or transmits any unsolicited advertising,
                      promotional materials, “junk mail”, “spam”, “chain
                      letters”, “pyramid schemes”, or any other form of
                      solicitation, commercial or otherwise;
                    </li>
                    <li class="mt-2">
                      decompiles, uses reverse engineering, disassembles,
                      derives the source code of or decrypts the Application or
                      server hosting the Application;
                    </li>
                    <li class="mt-2">
                      manipulates or otherwise displays the Application by using
                      framing, mirroring or similar navigational technology or
                      directly links to any portion of the Application;
                    </li>
                    <li class="mt-2">
                      uses any robot, spider, scraper or other automatic or
                      manual means to access the Application or copies any
                      content or information on the Application;
                    </li>
                    <li class="mt-2">
                      removes, obscures, or alters any proprietary notices
                      (including any notice of copyright or trademark) of us or
                      our affiliates, partners, suppliers or our licensors;
                    </li>
                    <li class="mt-2">
                      modifies, adapts, improves, enhances or makes any
                      derivative work from the Application;
                    </li>
                    <li class="mt-2">
                      disables, overburdens, impairs or otherwise interferes
                      with or interrupts the Application or any hardware,
                      software, system or network connected with the
                      Application;
                    </li>
                    <li class="mt-2">
                      probes,scans, or tests the vulnerability of or breaches
                      the authentication measures of the Application or any
                      related networks or systems;
                    </li>
                    <li class="mt-2">
                      interferes with any other party’s use and enjoyment of the
                      e Application;
                    </li>
                    <li class="mt-2">
                      infringes the copyright, trademark or any proprietary
                      rights or discloses a trade secret or confidential
                      information in violation of a confidentiality or
                      non-disclosure agreement;
                    </li>
                    <li class="mt-2">
                      compiles, uses, downloads or otherwise copies any user
                      information or any portion thereof, or transmits, provides
                      or otherwise distributes (whether or not for a fee) such
                      information to any third party;
                    </li>
                    <li class="mt-2">
                      is fraudulent, malicious or unlawful, unauthorized or
                      contains defamatory or illegal information, images,
                      materials or descriptions;
                    </li>
                    <li class="mt-2">
                      promotes or provides instructions for illegal activities;
                    </li>
                    <li class="mt-2">
                      encourages any conduct that would constitute a criminal
                      offense or that gives rise to civil liability;
                    </li>
                    <li class="mt-2">
                      disseminates viruses or other computer code, files or
                      programs that interrupt, destroy or limit the
                      functionality of any computer software or hardware;
                    </li>
                    <li class="mt-2">
                      attempts to gain unauthorized access to any other
                      accounts, computer systems or networks connected to any
                      server or systems through hacking, password mining or any
                      other means; or
                    </li>
                    <li class="mt-2">
                      accesses systems, data or information that we do not
                      intend to be made accessible to you.
                    </li>
                  </ul>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Right to Monitor</strong>
                  </span>

                  <p>
                    We reserve the right to actively monitor the use of the
                    Application and use any information gathered during such
                    monitoring for any permissible purpose under the Privacy
                    Policy. Additionally, we may, at any time as we deem
                    appropriate, remove any materials from the Application that,
                    in our sole discretion, may be illegal, may subject us to
                    liability, may violate these Terms, or are, in our sole
                    discretion, inconsistent with our purpose for the
                    Application.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Accuracy of Information</strong>
                  </span>

                  <p>
                    You must provide true, accurate, current and complete
                    information, and you may not misrepresent information (a) in
                    your registration information, (b) about your family members
                    or third-party providers, (c) about Health Information, or
                    (d) in the case of a Provider or healthcare professional,
                    your medical credentials or in any communications to a
                    patient. In order for the Application to function
                    effectively, you must also keep such information listed
                    above up-to-date and accurate. If you do not do this, the
                    accuracy and effectiveness of the Application will be
                    affected.
                  </p>
                  <p>
                    HealthBook+ may review the Health Information that you
                    maintain through the Application to normalize and label data
                    for display, but HealthBook+ is not responsible for any
                    errors in the Health Information resulting from such review
                    process. HealthBook+ makes no effort to review the Health
                    Information for any other purpose, including, but not
                    limited to, accuracy, legality or non-infringement.
                    HealthBook+ is not responsible for any Health Information
                    provided by you, third-party providers or their patient
                    portal sites. HealthBook+ cannot guarantee or assume
                    responsibility for the completeness, timeliness, accuracy,
                    relevance, deletion or non-delivery of any Health
                    Information.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Intellectual Property Rights</strong>
                  </span>
                  <p>
                    HealthBook+ retains all intellectual property rights in and
                    to the Application and all related documentation interest
                    (including all copyrights, patents, service marks,
                    trademarks and other intellectual property rights),
                    including, but not limited to, any and all updates,
                    enhancements, customizations, revisions, modifications,
                    future releases and any other changes thereto, and all
                    related information, material and documentation. Except for
                    rights specifically provided in these Terms, You hereby
                    assign to HealthBook+ all other intellectual property rights
                    it may now or hereafter possess in the Application and
                    related documentation, and all derivative works and
                    improvements thereof, and agree to execute all documents,
                    and take all actions, that may be necessary to confirm such
                    rights. You also agree to retain all proprietary marks,
                    legends and patent and copyright notices that appear on the
                    Application and any related documentation delivered to You
                    by HealthBook+ and all whole or partial copies thereof.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Proprietary Rights in Application Content</strong>
                  </span>
                  <p>
                    HealthBook+ retains all copyright and other exclusive rights
                    in the contents of the Application (the “Content”). Elements
                    of the Content are protected by copyright, trade dress and
                    other laws, and may not be copied or imitated in whole or in
                    part. Nothing shall be understood to be granting you any
                    license under any patent, trademark or copyright of
                    HealthBook+ or of any third-party. Even though the
                    Application may display certain third-party trademarks or
                    brand names, that does not mean that HealthBook+ owns or is
                    connected with those third-parties. Those third-party
                    trademarks are used only to identify the products and
                    services of their respective owners. Do not assume that
                    HealthBook+ sponsors or endorses those brands, products or
                    services. You are not permitted to use the trademarks
                    displayed on the Application without HealthBook+’s prior
                    written consent or the consent of the third-party that may
                    own the trademarks. No Content may be modified, copied,
                    distributed, framed, reproduced, republished, downloaded,
                    displayed, posted, transmitted or sold in any form or by any
                    means, in whole or in part, without HealthBook+’s prior
                    written permission. You may download or print a copy of any
                    portion of the Content solely for your personal,
                    noncommercial use, provided that you keep all copyright or
                    other exclusive notices intact. You may not republish
                    Content contained on the Application or include the
                    information in any other database or collection. Any other
                    use of the Content is strictly prohibited.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Legal Age</strong>
                  </span>
                  <p>
                    The Application is offered and available to users who are 18
                    years of age or older. By using the Application, you
                    represent and warrant that you are of legal age to form a
                    binding contract with HealthBook+ and meet all of the
                    foregoing eligibility requirements. If you are under the age
                    of 18, make sure that your parent or legal guardian reads
                    and agrees with these Terms on your behalf, as your parent
                    or legal guardian shall be fully responsible for your
                    compliance with these Terms. If you do not meet all of these
                    requirements, you must not access or use the Application.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong
                      >Data Collection and Exchange; Privacy Policy.</strong
                    >
                  </span>
                  <p>
                    Any personal information (for example, your name, address,
                    telephone number, e-mail address, Health Information) that
                    you transmit to, or receive from the Application shall be
                    subject to: (i) the terms in the Privacy Policy, available
                    at
                    <router-link :to="{ name: 'healthbookplus-privacy' }"
                      >www.healthbookplus.com/privacy</router-link
                    >; and (2) any applicable third-party data exchange terms
                    available at
                    <a
                      href="https://healthgorilla.com/home/policies/patient360-passthrough-terms"
                      >https://healthgorilla.com/home/policies/patient360-passthrough-terms
                    </a>
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Feedback</strong>
                  </span>
                  <p>
                    Providing any suggestions, enhancement requests,
                    recommendations, corrections or other feedback
                    (collectively, “Feedback”) is strictly voluntary. If you
                    provide any Feedback to HealthBook+, orally or in writing,
                    as between you and HealthBook+, HealthBook+ shall: (i) own,
                    exclusively, all now known or later discovered rights to the
                    Feedback; (ii) not be subject to any obligation of
                    confidentiality and shall not be liable for any use or
                    disclosure of any Feedback; and (iii) be entitled to
                    unrestricted use of the Feedback for any purpose whatsoever,
                    commercial or otherwise, without compensation to your or any
                    other person.
                  </p>
                </li>
              </ol>
            </li>
            <li :class="[$style.listHeading]">
              <h5>
                <strong>Providers and Authorized Individuals</strong>
              </h5>
              <ol type="1">
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Providers</strong></span
                  >
                  <p>
                    Through the Application, you may authorize your
                    participating healthcare providers (“Providers”) to provide
                    Health Information about you from the Providers’ electronic
                    health records to the Application. You may use the
                    Application to share certain Health Information with such
                    Providers. You may use the Application to communicate with
                    such Providers. You understand that any decision to use the
                    Application in such ways is entirely voluntary. You
                    understand that if you authorize a Provider to access your
                    Health Information in the Application and communicate with
                    you via the Application, Provider may permit its/his/her
                    staff and other authorized users within its/his/her facility
                    or office to use the Application to access your Health
                    Information and communicate with you as well.
                  </p>
                  <p>
                    HealthBook+ relies on the Providers authorized by you to
                    confirm that they meet the criteria for interacting with the
                    Application. You acknowledge and agree that HealthBook+ is
                    not responsible for any such entity misidentifying itself or
                    any misuse of the data, or acts or omissions by such health
                    care providers or their authorized personnel. HealthBook+’s
                    sole liability and sole responsibility shall be to
                    discontinue access to any entity or individual which
                    HealthBook+ learns misidentified itself/himself/herself or
                    is otherwise misusing data. You are responsible for choosing
                    your own healthcare provider, including any Provider. You
                    are responsible for determining whether the applicable
                    healthcare provider is suitable for your healthcare needs
                    based on specialty, experience, qualification, licenses and
                    other important facts and circumstances that could impact
                    your care. You must review and assess the qualifications of
                    your Providers and to make appropriate decisions with
                    respect to Authorized Individuals (as defined below).
                    HealthBook+ does not examine the credentials of, perform
                    background checks on, or give its endorsement to any
                    healthcare provider, Provider or Authorized Individual.
                  </p>
                  <p>
                    Conversely, if you are a Provider, for the avoidance of
                    doubt, you acknowledge and agree that you are subject to
                    these Terms and the Privacy Policy. You may receive Health
                    Information through the Application from your patients. You
                    may use the Application to share information and communicate
                    with such patients. You understand that any decision to use
                    the Application is entirely voluntary and should not be the
                    only way to evaluate patients. You are solely responsible
                    for the medical diagnosis and treatment of your patients,
                    and should take steps to ensure that all information
                    received via the Application is accurate for the diagnoses
                    and treatment of an individual. You acknowledge and agree
                    that HealthBook+ shall have no responsibility or liability
                    for any claims arising out of the use of the Application.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Authorized Individuals</strong>
                  </span>
                  <p>
                    You may grant also access to Health Information or your
                    account to one or more individuals (“Authorized
                    Individuals”). You may grant an Authorized Individual access
                    to your account by specifically authorizing HealthBook+ to
                    permit access by such Authorized Individual to your account.
                    When you grant access to an Authorized Individual, you may
                    permit the Authorized Individual to: (a) have the same level
                    of access to your HealthBook+ account as you have, i.e., the
                    Authorized Individual will be authorized to access your
                    HealthBook+ health record and to communicate with your
                    Providers and/or engage in other transactions with your
                    Providers to the same extent that you are able using
                    HealthBook+; or (b) have "read-only" access to your
                    HealthBook+ account, i.e., the Authorized Individual will be
                    authorized to access your Health Information ONLY, and will
                    NOT be able to communicate with or otherwise engage in
                    transactions with your Providers. Whether or not you grant
                    an Authorized Individual full-access or read-only access to
                    your HealthBook+ account is your decision. You acknowledge
                    and agree that: (a) you are solely responsible for verifying
                    the identity of, and monitoring the use by, any Authorized
                    Individual you select; and (b) HealthBook+ has no
                    responsibility or liability in connection with any access
                    to, or use of, your account and information by any
                    Authorized Individual. Conversely, if you are an Authorized
                    Individual, you agree that you are also subject to these
                    Terms and the Privacy Policy and acknowledge and agree
                    HealthBook+ shall have no responsibility or liability for
                    any claims arising out of the use of the Application.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Revoking Access</strong></span
                  >
                  <p>
                    End-Users who are patients of Providers using the
                    Application may revoke any Provider's, other third-party's,
                    or Authorized Individual’s permission to (a) communicate
                    with you through the Application; (b) request information
                    from you or your Health Information through the Application;
                    or (c) provide Health Information to your HealthBook+
                    account by utilizing the connection management features of
                    the Application. However, copies of all of your Health
                    Information previously disclosed to such Providers, third
                    parties, or Authorized Individuals and incorporated into
                    such Providers', third-parties', or Authorized Individuals'
                    records, if any, may remain in such records. HealthBook+
                    cannot, and has no obligation to, remove such information
                    from the Providers’, third-parties’, or Authorized
                    Individuals’ records.
                  </p>
                </li>
              </ol>
            </li>
            <li :class="[$style.listHeading]">
              <h5>
                <strong
                  >Warranties, Disclaimers, and Limitations of Liability</strong
                >
              </h5>
              <ol type="1">
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>No Specific Results</strong></span
                  >
                  <p>
                    HealthBook+ does not represent, warrant or otherwise
                    guarantee: (a) the reliability and suitability of the
                    Application; (b) the effectiveness, suitability or
                    reliability of communicated information (including any data
                    provided through the Application); (c) that the Application
                    will work without interruption or that it will be free of
                    errors, viruses or other harmful components; (d) outcomes
                    resulting from your use of the Application; (e) that the
                    information available on or through the Application is
                    comprehensive or exhaustive, or that it addresses all
                    relevant symptoms, medicines, and treatments for various
                    diseases or medical conditions; or (f) any outcome with
                    respect to health and well-being as a result of the
                    application of this information.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong
                      >We Do Not Practice Medicine; Do Not Use In a Medical
                      Emergency</strong
                    ></span
                  >
                  <p>
                    The information contained on the Application and, our
                    Content and any other information provided by HealthBook+
                    are for general guidance only. HealthBook+ provides certain
                    symptom checking symptoms through a third party in order to
                    present information about potential medical conditions,
                    which may or may not be directly related to symptoms and
                    illnesses communicated by you, and may not be accurate.
                    HealthBook+ may also provide for use of Artificial
                    Intelligence, or “AI”. AI generated content is experimental
                    and for informational purposes only. Such information may
                    not be accurate. The Application is not intended to be, and
                    must not be taken to be, the practice of medicine or other
                    healthcare services by HealthBook+ and does not replace a
                    medical diagnosis by a physician or healthcare provider. The
                    Application should not be used in a medical emergency. Use
                    of the Application does not create a physician/patient or
                    provider/patient relationship with HealthBook+. HealthBook+
                    is not recommending or endorsing any specific treatment,
                    physician, healthcare provider or medication. All Providers
                    are not affiliated with HealthBook+ and HealthBook+ is not
                    liable for any information, content, advice, communications,
                    or acts or omissions of Providers.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>No Warranties</strong></span
                  >
                  <p>
                    <strong>
                      YOU UNDERSTAND AND AGREE THAT THE APPLICATION IS PROVIDED
                      ON AN "AS IS" AND "AS AVAILABLE" BASIS AND THAT
                      HEALTHBOOK+ DISCLAIMS ANY AND ALL WARRANTIES RELATING TO
                      THE APPLICATION, OR ANY OTHER MATTER COVERED BY THIS
                      AGREEMENT, INCLUDING, WITHOUT LIMITATION, ANY IMPLIED
                      WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR
                      PURPOSE. HEALTHBOOK+ DOES NOT WARRANT THAT THE APPLICATION
                      WILL MEET YOUR REQUIREMENTS, WILL OPERATE WITHOUT
                      INTERRUPTION OR DELAY AND/OR BE ERRORFREE, OR THAT ANY
                      ERRORS CAN OR WILL BE CORRECTED. HEALTHBOOK+ MAKES NO
                      WARRANTIES OR REPRESENTATIONS AS TO THE ACCURACY OF ANY
                      INFORMATION OR CONTENT PROCESSED BY THE APPLICATION.
                      MATERIAL DOWNLOADED OR OTHERWISE OBTAINED THROUGH THE USE
                      OF THE APPLICATION IS DONE AT YOUR OWN CHOOSING AND RISK,
                      AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR
                      COMPUTER SYSTEM OR LOSS OF DATA THAT RESULTS FROM THE
                      DOWNLOAD OF ANY SUCH MATERIAL.
                    </strong>
                  </p>
                  <p>
                    <strong>
                      SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN
                      WARRANTIES. ACCORDINGLY, SOME OF THE ABOVE LIMITATIONS MAY
                      NOT APPLY TO YOU.
                    </strong>
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Limitations of Liability</strong></span
                  >
                  <p>
                    <strong>
                      IN NO EVENT SHALL HEALTHBOOK+, OR OUR DIRECTORS, OFFICERS,
                      EMPLOYEES OR AGENTS OR THIRD PARTY LICENSORS BE LIABLE FOR
                      LOST PROFITS OR BUSINESS, LOSS OF GOODWILL, LOSS OF DATA,
                      INTERRUPTION OF BUSINESS, OR FOR ANY EXEMPLARY, PUNITIVE,
                      SPECIAL, INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES,
                      REGARDLESS OF WHETHER SUCH DAMAGES ARISE UNDER ANY THEORY
                      OF TORT, CONTRACT, STRICT LIABILITY OR OTHERWISE AND
                      REGARDLESS OF WHETHER SUCH PARTY IS ADVISED OF THE
                      POSSIBILITY OF ANY SUCH DAMAGES.
                    </strong>
                    The aggregate liability of HealthBook+ for any and all
                    claims arising under or in connection with these Terms or
                    its subject matter shall not exceed $100. The above
                    limitation, or exclusion, may not apply to you to the extent
                    that applicable law prohibits the limitation or exclusion of
                    liability for incidental or consequential damages.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Telecommunication Service</strong></span
                  >
                  <p>
                    Use of the Application may be available through a compatible
                    mobile device, Internet and/or network access and may
                    require software. You agree that you are solely responsible
                    for these requirements, including any applicable changes,
                    updates and fees as well as the terms of your agreement with
                    your mobile device and telecommunications providers.
                    <strong>
                      HEALTHBOOK+ MAKES NO WARRANTIES OR REPRESENTATIONS OF ANY
                      KIND, EXPRESS, STATUTORY OR IMPLIED AS TO: (a) THE
                      AVAILABILITY OF TELECOMMUNICATION SERVICES AND ACCESS TO
                      THE APPLICATION AT ANY TIME OR FROM ANY LOCATION; (b) ANY
                      LOSS, DAMAGE, OR OTHER SECURITY INTRUSION OF THE
                      TELECOMMUNICATION SERVICES; AND (c) ANY DISCLOSURE OF
                      INFORMATION TO THIRD PARTIES OR FAILURE TO TRANSMIT ANY
                      DATA, COMMUNICATIONS OR SETTINGS CONNECTED WITH THE
                      APPLICATION.
                    </strong>
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Interruptions</strong></span
                  >
                  <p>
                    Your access and use of the Application may be interrupted
                    from time to time for any of several reasons, including,
                    without limitation, unanticipated system failures, the
                    malfunction of equipment, periodic updating, maintenance or
                    repair of the Application, or other actions beyond the
                    control of HealthBook+ or that HealthBook+, in its sole
                    discretion, may elect to take. HealthBook+ cannot always
                    foresee or anticipate technical or other difficulties which
                    may result in, and HealthBook+ shall therefore not be
                    responsible orliable for, any (a) failure to obtain Health
                    Information, (b) loss of Health Information or
                    personalization settings, or (c) other service
                    interruptions.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Third Party Disclaimer</strong></span
                  >
                  <p>
                    HealthBook+ may engage third party service providers,
                    contractors, or partners to perform certain functions on its
                    behalf. You acknowledge and agree that your use of any third
                    party services, integrations, or features provided through
                    or in connection with HealthBook+ is at your own risk and
                    subject to such third party’s own terms and privacy
                    practices. HealthBook+ expressly disclaims any and all
                    liability for any loss, damage, or harm arising from the
                    acts or omissions of third parties.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong> Essential Part of the Bargain </strong>
                  </span>
                  <p>
                    The parties acknowledge that the disclaimers and limitations
                    set forth in this Section 3 are an essential element of
                    these Terms between the parties and the parties would not
                    have entered into these Terms without such disclaimers and
                    limitations.
                  </p>
                </li>
              </ol>
            </li>

            <li :class="[$style.listHeading]">
              <h5>
                <strong>Indemnification; Unauthorized Use</strong>
              </h5>
              <ol type="1">
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Indemnification</strong>
                  </span>
                  <p>
                    You agree to indemnify, defend, and hold us and our
                    subsidiaries, affiliates, officers, agents, employees,
                    contractors, partners and third party licensors harmless
                    from and against any and all suits, actions, losses, claims,
                    proceedings, demands, expenses, damages, settlements,
                    judgments, injuries, liabilities, obligations, risks, and
                    costs, including, without limitation, reasonable attorneys’
                    fees, due to, relating to, or arising out of: (i) your use
                    of the Application; (ii) your violation of these Terms;
                    (iii) any Feedback you provide; (iv) your negligence, fraud,
                    or willful misconduct; (v) your user account; and/or (vi)
                    your violation of any law or regulation or any rights of
                    another. We reserve the right, at your expense, to assume
                    the exclusive defense and control of any matter which you
                    are required to indemnify against, and you agree to
                    cooperate in our defense of such matter.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong> Notification of Unauthorized Use </strong>
                  </span>
                  <p>
                    You shall promptly notify HealthBook+ in writing upon its
                    discovery of any unauthorized use or infringement of the
                    Application, or the related documentation, or HealthBook+'s
                    intellectual property rights with respect thereto.
                    HealthBook+ shall have the sole and exclusive right to bring
                    an infringement action or proceeding against any infringing
                    third party and, in the event that HealthBook+ brings such
                    an action or proceeding, you shall cooperate and provide
                    full information and assistance to HealthBook+ and its
                    counsel in connection with any such action or proceeding.
                  </p>
                </li>
              </ol>
            </li>

            <li :class="[$style.listHeading]">
              <h5>
                <strong>Term and Termination</strong>
              </h5>
              <ol type="1">
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Term</strong></span
                  >
                  <p>
                    Your access to the Application shall begin on the date you
                    register for the Application and shall continue until
                    terminated under the provisions of this Section 5.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Termination for Convenience</strong></span
                  >
                  <p>
                    HealthBook+ may terminate your access to all or part of the
                    Application at any time with or without notifying you. You
                    may terminate access to the Application at any time by
                    canceling your account.
                  </p>
                </li>

                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Effect of Termination</strong></span
                  >
                  <p>
                    Upon the termination, all license rights of End-User under
                    these Terms regarding the Application shall automatically
                    and immediately cease, and End-User shall promptly cease all
                    uses of the Application. Sections 2, 3, 4, 5.3, 6, 7 and 8
                    shall survive the expiration or sooner termination of these
                    Terms.
                  </p>
                </li>
              </ol>
            </li>

            <li :class="[$style.listHeading]">
              <h5>
                <strong>General</strong>
              </h5>
              <ol type="1">
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong> Electronic Communications and Notice </strong>
                  </span>
                  <p>
                    When you use the Application or send e-mails to us, you are
                    communicating with us electronically and you consent to
                    receive communications from us electronically. We will
                    communicate with you by e-mail at the address we have on
                    file for you (if any), sending you messages through the
                    mobile application we provide, or by posting notices on the
                    Application. You agree that all agreements, notices,
                    disclosures and other communications that we provide to you
                    electronically satisfy any legal requirement that such
                    communications be in writing. You further agree that any
                    notices provided by us electronically are deemed to be given
                    and received on the date we transmit any such electronic
                    communication as described in these Terms.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Force Majeure</strong>
                  </span>
                  <p>
                    In the event that HealthBook+ is unable to perform its
                    obligations under these Terms because of acts of God,
                    strikes, equipment or transmission failure, unavailability
                    or poor performance of the Internet, or other causes
                    reasonably beyond its control, HealthBook+ shall not be
                    liable for any damages resulting from such failure to
                    perform or otherwise from such causes.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong> Time Limit on Claims Against Us </strong>
                  </span>
                  <p>
                    You agree that any claim you may have arising out of or
                    related to your use of the Application or your relationship
                    with us must be filed within one (1) year after such claim
                    arose; otherwise, your claim is permanently barred.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Governing Law</strong>
                  </span>
                  <p>
                    This Agreement is governed by the laws of the State of
                    Colorado, without regard to its choice of law provisions.
                    The courts of general jurisdiction located within Jefferson
                    County, Colorado, will have exclusive jurisdiction over any
                    and all disputes arising out of, relating to or concerning
                    these Terms or in which these Terms are a material fact.
                    HealthBook+ makes no representation that materials contained
                    on the Application are appropriate or available for use in
                    other locations, and accessing them from territories where
                    their contents are illegal is prohibited. If you choose to
                    access the Application from other locations, you do so by
                    your own choice, and you alone are responsible for obeying
                    local laws.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Our Remedies</strong></span
                  >
                  <p>
                    You agree that any violation, or threatened violation, by
                    you of these Terms constitutes an unlawful and unfair
                    business practice that will cause us or (as applicable) our
                    third party software licensors irreparable and
                    unquantifiable harm. You also agree that monetary damages
                    would be inadequate for such harm and consent to our
                    obtaining any injunctive or equitable relief that we deem
                    necessary or appropriate. These remedies are in addition to
                    any other remedies we may have at law or in equity.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Dispute Resolution</strong>
                  </span>
                  <p>
                    Any controversy or claim between the parties or arising out
                    of these Terms or any use of the Application shall be
                    determined by one disinterested arbitrator in binding
                    arbitration pursuant to the Commercial Arbitration Rules and
                    the Supplementary Proceduresfor Online Arbitration of the
                    American Arbitration Association (the "AAA"). The arbitrator
                    shall be experienced in agreements for information
                    technology services, either as an attorney or as an
                    information technology professional. If the parties fail to
                    appoint an arbitrator within forty-five (45) days of the
                    institution of the arbitration, the AAA shall select the
                    arbitrator promptly thereafter. Any requests for
                    accelerated, emergency or preliminary relief shall be
                    submitted pursuant to the AAA’s Optional Rules for Emergency
                    Measures of Protection. If any such requests are made before
                    an arbitration panel is empaneled, then the AAA shall
                    appoint one disinterested arbitrator as an arbitration panel
                    to immediately hear and decide such request. The arbitration
                    panel shall have the right to grant interim awards.
                    Testimony shall be permitted by telephone, video conference
                    and other forms of real-time telecommunications. If the
                    arbitrator requiresin-person hearings, the hearings shall be
                    held in Denver, Colorado. The arbitral award will be final
                    and binding, and may be entered and enforced in any court of
                    competent jurisdiction.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong> Waiver of Jury Trial and Class Actions </strong>
                  </span>
                  <p>
                    <strong>
                      BY ENTERING INTO THIS AGREEMENT, YOU AND HEALTHBOOK+
                      ACKNOWLEDGE AND AGREE TO WAIVE CERTAIN RIGHTS TO LITIGATE
                      DISPUTES IN COURT, TO RECEIVE A JURY TRIAL OR TO
                      PARTICIPATE AS A PLAINTIFF OR AS A CLASS MEMBER IN ANY
                      CLAIM ON A CLASS OR CONSOLIDATED BASIS OR IN A
                      REPRESENTATIVE CAPACITY. YOU AND HEALTHBOOK+ BOTH AGREE
                      THAT ANY ARBITRATION WILL BE CONDUCTED ON AN INDIVIDUAL
                      BASIS AND NOT A CONSOLIDATED, CLASS-WIDE OR REPRESENTATIVE
                      BASIS AND THE ARBITRATOR SHALL HAVE NO AUTHORITY TO
                      PROCEED WITH AN ARBITRATION ON A CLASS OR REPRESENTATIVE
                      BASIS. THE ARBITRATOR MAY AWARD INJUNCTIVE RELIEF ONLY IN
                      FAVOR OF THE INDIVIDUAL PARTY SEEKING RELIEF AND ONLY TO
                      THE EXTENT NECESSARY TO PROVIDE RELIEF WARRANTED BY THAT
                      PARTY’S INDIVIDUAL CLAIM. IF FOR ANY REASON THE
                      ARBITRATION CLAUSE SET FORTH IN THIS AGREEMENT IS DEEMED
                      INAPPLICABLE OR INVALID, OR TO THE EXTENT THE ARBITRATION
                      CLAUSE ALLOWS FOR LITIGATION OF DISPUTES IN COURT, YOU AND
                      HEALTHBOOK+ BOTH WAIVE, TO THE FULLEST EXTENT ALLOWED BY
                      LAW, ANY RIGHT TO PURSUE OR TO PARTICIPATE AS A PLAINTIFF
                      OR AS A CLASS MEMBER IN ANY CLAIM ON A CLASS OR
                      CONSOLIDATED BASIS OR IN A REPRESENTATIVE CAPACITY.
                    </strong>
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Third-Party Sites</strong>
                  </span>
                  <p>
                    The Application may contain links to third-party websites,
                    applications, or services. HealthBook+ is not responsible
                    for the content, accuracy or opinions expressed on those
                    third-party websites, applications, or services, and those
                    third-party websites are not investigated, monitored or
                    checked for accuracy or completeness by us. Inclusion of any
                    linked third-party website, application, or service on or
                    through the Application does not imply approval or
                    endorsement of the linked third-party website, application,
                    or service by HealthBook+. If you decide to leave the
                    Application and accessthese third-party websites,
                    applications, orservices, you do so at your own risk.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Assignment</strong>
                  </span>
                  <p>
                    You may not assign any of HealthBook+’s rights or
                    privileges, or delegate any of its duties or obligations
                    hereunder to any third party without the prior written
                    consent of HealthBook+. Any purported assignment in
                    contravention of this Section shall be null and void.
                    Subject to the foregoing, these Terms shall be binding upon
                    and inure to the benefit of the parties hereto and their
                    respective permitted successors and assigns.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Notices</strong>
                  </span>
                  <p>
                    All notices and other communications hereunder shall be in
                    writing and shall be deemed effective when delivered by
                    hand, facsimile transmission, reputable overnight delivery
                    service, or certified mail (return receipt requested),
                    postage prepaid to: (a) in the case of End User, to the
                    address set forth in its account information, and (b) in the
                    case of HealthBook+:
                  </p>
                  <p>Healthbook Plus Holdings, Inc</p>
                  <p>Chris Turner</p>
                  <p>3513 Brighton Blvd</p>
                  <p>Ste 415</p>
                  <p>Denver CO 80216</p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Waiver</strong></span
                  >
                  <p>
                    A waiver by Healthbook+ of a breach or violation of any
                    provision of these Terms will not constitute or be construed
                    as a waiver of any subsequent breach or violation of that
                    provision or as a waiver of any breach or violation of any
                    other provision of these Terms.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Severability</strong>
                  </span>
                  <p>
                    If any provision of these Terms is held to be unenforceable,
                    it shall be severed and the remaining provisions will remain
                    enforceable. The severed provision will be replaced by an
                    enforceable provision most nearly reflecting the intention
                    of the parties.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Headings</strong>
                  </span>
                  <p>
                    The section titles of these Terms are displayed for
                    convenience only and have no legal effect.
                  </p>
                </li>
                <li class="my-4">
                  <span :class="$style.subListHeading">
                    <strong>Third-Party Beneficiaries</strong>
                  </span>
                  <p>
                    Nothing in these Terms shall be deemed to give any
                    third-party rights or benefits except as follows: Our third
                    party licensors shall be a third party beneficiary with
                    respect to these Terms with respect to your use of the third
                    party software aspects of the Application.
                  </p>
                </li>
              </ol>
            </li>
          </ol>
        </div>
        <div :class="[$style.standardOrderList]">
          <ol type="1" start="7" class="pl-4">
            <li :class="['mt-4', $style.listHeading]">
              <h5 class="pl-1">
                <strong>App Provider Terms. </strong>
              </h5>
              <p class="pt-5">
                The following terms apply to any mobile version of the
                Application (“App”) accessed through or downloaded from Apple
                Inc. or Google LLC (each, an “App Provider”). You acknowledge
                and agree that:
              </p>
              <ol type="i">
                <li class="my-4">
                  These Terms are concluded between you and HealthBook+, and not
                  with the App Provider, and that HealthBook+ (not the App
                  Provider), is solely responsible for the App.
                </li>
                <li class="my-4">
                  To the extent you obtain an App from the Apple App Store, any
                  licenses granted hereunder for the use of the App are limited
                  to a license to use the App on any Apple-Platformed Products
                  that you own or control and as permitted by the Usage Rules
                  set forth in the App Store Terms of Service, except that the
                  App may be accessed and used by other accounts associated with
                  you via family sharing or volume purchasing.
                </li>
                <li class="my-4">
                  Unless expressly stated otherwise in writing by the App
                  Provider, the App Provider has no obligation to furnish any
                  maintenance and support services with respect to the App.
                </li>
                <li class="my-4">
                  You may notify the App Provider in the event of any failure of
                  the App to conform to any applicable warranty, and the App
                  Provider will refund the purchase price for the App to you (if
                  applicable) and to the maximum extent permitted by applicable
                  law, the App Provider will have no other warranty obligation
                  whatsoever with respect to the App. To the extent that
                  HealthBook+ is not the App Provider, any claims, losses,
                  liabilities, damages, costs or expenses other than the
                  purchase price attributable to any failure to conform to any
                  warranty will be the sole responsibility of HealthBook+ in
                  accordance with these Terms
                </li>
                <li class="my-4">
                  The App Provider is not responsible for addressing any claims
                  you have or any claims of any third party relating to the App
                  or your possession and use of the App, including, but not
                  limited to: (A) product liability claims; (B) any claim that
                  the App fails to conform to any applicable legal or regulatory
                  requirement; or (C) claims arising under consumer protection
                  or similar legislation.
                </li>
                <li class="my-4">
                  In the event of any third party claim that the App or your
                  possession and use of that App infringes that third party’s
                  intellectual property rights, HealthBook+, and not App
                  Provider, will be solely responsible for the investigation,
                  defense, settlement, and discharge of any such intellectual
                  property infringement claim to the extent required by these
                  Terms.
                </li>
                <li class="my-4">
                  You represent and warrant that (i) you are not located in a
                  country that is subject to a U.S. Government embargo, or that
                  has been designated by the U.S. Government as a “terrorist
                  supporting” country; and (ii) you are not listed on any U.S.
                  Government list of prohibited or restricted parties.
                </li>
                <li class="my-4">
                  You must also comply with all applicable third party terms of
                  service when using the App
                </li>
                <li class="my-4">
                  The App Provider, and its subsidiaries, are third party
                  beneficiaries of these Terms as related to your license of the
                  App, and that, upon your acceptance of the terms and
                  conditions of these Terms, the App Provider will have the
                  right (and will be deemed to have accepted the right) to
                  enforce these Terms asrelated to your license of the App
                  against you as a third party beneficiary thereof.
                </li>
                <li class="my-4">
                  You further agree to comply with the App Providers’ terms and
                  conditions: (a) Apple Media Services Terms and Conditions
                  (available at:
                  <a
                    href="https://www.apple.com/legal/internetservices/itunes/us/terms.html"
                  >
                    https://www.apple.com/legal/internetservices/itunes/us/terms.html </a
                  >); and (b) Google Play Terms of Service (available at:
                  <a href="https://play.google.com/about/play-terms/index.html">
                    https://play.google.com/about/play-terms/index.html </a
                  >), which are incorporated herein and made a part of these
                  Terms by this reference.
                </li>
              </ol>
            </li>
            <li :class="['mt-8', $style.listHeading]">
              <h5 class="pb-5 pl-1">
                <strong>Supplemental Terms Applicable to Providers</strong>
              </h5>
              <span :class="$style.subListHeading">
                <strong>General</strong>
              </span>
              <p>
                These supplemental terms apply to Providers in addition to the
                other provisions of these Terms of Use. In the event of a
                conflict between the supplemental terms and any other terms
                herein, the supplemental terms shall prevail.
              </p>
              <p>
                If you are a Provider using the Application, you must be a
                physician or other healthcare professional or other authorized
                provider group, and duly licensed/registered under applicable
                state and international law, as required, and agree to comply
                with all laws, professional licensing board rules and other
                rules and regulations applicable to you as a Provider or
                otherwise. You represent and warrant that, at all times while
                using the Application, you have medical malpractice insurance
                coverage satisfying the requirements of all jurisdictions in
                which you are licensed or registered. Your relationship with the
                other HealthBook+ End-Users (including your patients) is
                directly between you and the End-User that is a patient. The
                patient will never have a physician-patient or provider-patient
                relationship with HealthBook+. HealthBook+ does not practice
                medicine and offers no medical or healthcare services. You are
                solely responsible for all agreements, consents, notices and
                other interactions with patients and other consumers. Without
                limiting the generality of the foregoing, you (or your own
                provider group as applicable) are solely responsible for all
                billings and collections from patients and other consumers, and
                HealthBook+ shall have no liability to you as the Provider or
                any End-User, or third party whatsoever with respect to any
                amounts owed by any patient or other consumer to Provider.
              </p>
              <p>
                HealthBook+ does not provide any medical advice, legal advice,
                or representations in any way regarding any legal or medical or
                healthcare issues associated with Provider including but not
                limited to any compliance obligations or steps necessary to
                comply with any state or federal laws and regulations. Provider
                should seek legal counsel regarding any legal and compliance
                issues, and must not rely on any materials or content associated
                with the Services in determining Provider’s compliance
                obligations under law. Provider and HealthBook+ agree that
                HealthBook+ is not providing, to the End-Users or anyone else,
                medical advice or legal advice.
              </p>
              <p>
                Provider will use the Application and the Services only in
                accordance with applicable standards of good medical or
                healthcare practice. While software products such as the
                Application and Services can facilitate and improve the quality
                of service that Provider can offer patients, many factors,
                including the provider-patient relationship, can affect a
                patient outcome, and with intricate and interdependent
                technologies and complex decision-making it is often difficult
                or impossible to accurately determine what the factors were and
                in what proportion they affected an outcome. Provider shall be
                solely responsible for its use of the Application and Services,
                and the provision of medical or healthcare services to
                Provider’s patients. In this regard, Provider releases
                HealthBook+ and waives any and all potential claims against
                HealthBook+ as a result of Provider’s use of the Application and
                Services, and the provision of services to Provider’s patients.
              </p>
              <p>
                <strong>
                  As a result of the complexities and uncertainties inherent in
                  the patient care process, Provider agrees to defend, indemnify
                  and hold HealthBook+ harmless from any claim by or on behalf
                  of any patient of Provider, or by or on behalf of any other
                  third party or person claiming damage by virtue of a familial
                  or financial relationship with such a patient, which is
                  brought against HealthBook+, regardless of the cause if such
                  claim arises for any reason whatsoever, out of Provider’s use
                  or operation of the Application and Services.
                </strong>
                Provider will obtain HealthBook+’s prior written consent to any
                settlement or judgment in which Provider agrees to any finding
                of fault of HealthBook+ or defect in the Application or
                Services. HealthBook+ will promptly notify Provider in writing
                of any claim subject to this indemnification, promptly provide
                Provider with the information reasonably required for the
                defense of the same, and grant to Provider exclusive control
                over its defense and settlement.
              </p>
              <p>
                If you submit, upload, transmit, or post any consents, notices,
                advice, recommendations, comments, files, videos, images or
                other materials to us or the Application (“Provider Content”) or
                provide any Provider Content to patients or other consumers, you
                agree not to provide any Provider Content that (1) is
                defamatory, abusive, libelous, unlawful, obscene, threatening,
                harassing, fraudulent, pornographic, or harmful, or that could
                encourage criminal or unethical behavior, (2) violates or
                infringes the privacy, copyright, trademark, trade dress, trade
                secrets or intellectual property rights of any person or entity,
                or (3) contains or transmits a virus or any other harmful
                component. Provider is solely responsible for obtaining all
                necessary agreements and consents from, and providing all
                required notices to, patients and other consumers that are
                EndUsers. You agree not to contact other End-Users through
                unsolicited e-mail, telephone calls, mailings or any other
                method of communication. You represent and warrant to
                HealthBook+ that you have the legal right and authorization to
                upload all Provider Content at the Application. HealthBook+
                shall have a royalty-free, irrevocable, transferable right and
                license to use the Provider Content however HealthBook+ desires,
                including without limitation, to copy, modify, delete in its
                entirety, adapt, publish, translate, create derivative works
                from or sell or distribute such Provider Content or incorporate
                such Provider Content into any form, medium, or technology
                throughout the world in accordance with applicable law.
                HealthBook+ is and shall be under no obligation (1) to maintain
                any Provider Content in confidence except as required by law;
                (2) to pay to you any compensation for any Provider Content; or
                (3) to respond to any Provider Content.
              </p>
              <p>
                HealthBook+ does not regularly review Provider Content but does
                reserve the right (but not the obligation) to monitor and edit
                or remove any Provider Content submitted to the Application. You
                grant HealthBook+ the right to use the name that you submit in
                connection with any Provider Content. You agree not to use a
                false email address, impersonate any person or entity, or
                otherwise mislead as to the origin of any Provider Content. You
                are and shall remain solely responsible for the content of any
                Provider Content you post to the Application or provide.
                HealthBook+ and its affiliates shall have no responsibility and
                assume no liability for any Provider Content submitted by you or
                any third party.
              </p>
              <span :class="$style.subListHeading">
                <strong> Access Rights of the Provider’s Accounts </strong>
              </span>
              <p>
                We offer the Services to Providers and to natural persons who
                are members of such Providers’ Authorized Workforce, as more
                fully described below. All persons who sign up for an account on
                behalf of a Provider may furnish, among other things, that
                Provider’s full legal name and fictitious business name(s)
                (i.e., trade name, d/b/a or “doing business as”) as part of the
                sign-up process. We treat the Provider in whose name the account
                is established as the owner of all accounts associated with such
                Provider, and we call this Provider the “Provider of Record.”
              </p>
              <p>
                The Provider of Record is a party to this Agreement for all
                purposes and shall be subject to all of the provisions are
                applicable to the person addressed as “you” in this Agreement.”
                Although a member of a Provider of Record’s Authorized Workforce
                may have signed-up for an account or electronically entered into
                this Agreement, or may continue to administer Administrative
                Rights on the Provider of Record’s behalf, only the Provider of
                Record is entitled to any of the rights, remedies, or benefits
                under this Agreement and control over the Administrative Rights.
                The Provider of Record is likewise subject to, and we may
                enforce against, all of the covenants, obligations,
                restrictions, limitations, acknowledgements, Consents,
                representations, warranties, waivers, and releases included in
                this Agreement. The Provider of Record may delegate
                Administrative Rights to one or more members of the Provider of
                Record’s Authorized Workforce, but the Provider of Record
                remains responsible for all activity occurring thereunder.
              </p>
              <ol type="1">
                <li class="my-4">
                  Authorized Representatives. An authorized representative of a
                  Provider may obtain an account on behalf of such Provider, and
                  may have administrative privileges on the account. We call the
                  person(s) authorized to act on behalf of a Provider the
                  “Authorized Representative(s)” of such Provider. The Provider
                  and Authorized Representative may be the same person. If you
                  are establishing an account or taking any action with respect
                  to a Provider’s account, you represent and warrant that (a)
                  you have the authority to act on such Provider’s behalf either
                  as owner/principal or as a member of such Provider’s
                  Authorized Workforce, (b) the information you submit is
                  complete and accurate, and (c) you have the authority to enter
                  into this Agreement on behalf of such Provider and bind such
                  Provider to the covenants, obligations, restrictions,
                  limitations, acknowledgements, consents, representations,
                  warranties, grants, waivers and releases contained in this
                  Agreement. If you are an Authorized Representative, you
                  recognize that you have no personal rights with respect to
                  such Provider’s account, and that such Provider may change the
                  Authorized Representative at any time, for any or no reason,
                  with or without notice.
                </li>
                <li class="my-4">
                  Authorized Workforce. If you are a member of a Provider’s
                  Authorized Workforce, and such Provider has authorized you to
                  access the Services on its behalf by authorizing a HealthBook+
                  Account ID or credential for you, then you are authorized
                  under this Agreement to access the Services solely on behalf
                  and at the direction of such Provider. As such, you may sign
                  in and use the functionality of the Services solely on behalf
                  and at the direction of such Provider. You consent to and
                  authorize the disclosure to such Provider any content related
                  to, or otherwise generated by your use of the Services,
                  including secure messages. You hereby agree and acknowledge
                  that you are subject to, and we may enforce against you, all
                  of the covenants, obligations, restrictions, limitations,
                  acknowledgements, consents, representations and warranties set
                  forth in this Agreement that are applicable to the person
                  addressed as “you” in this Agreement, and you hereby grant and
                  make all rights, waivers and releases set forth in this
                  Agreement that are granted and made by the person addressed as
                  “you” in this Agreement, but you are entitled to none of, and
                  hereby waive and agree not to exercise or assert any of, the
                  rights, remedies or benefits under this Agreement other than
                  the limited, non-exclusive, nontransferable, personal right
                  under this Section to sign in and use the functionality of the
                  Services solely on behalf and direction of such Provider.
                  Notwithstanding anything else to the contrary herein, you
                  acknowledge that your access to the Services may be terminated
                  by the Provider or us at any time, for any reason or no reason
                  at all, with or without notice. By (i) accessing any of the
                  Services under a Provider’s Accounts, or (ii) contacting us by
                  any means and requesting or directing us to take any action
                  with respect to any Provider’s Accounts or data held by such
                  account(s), or (iii) asserting any right or authority with
                  respect to such account(s) or data, you represent and warrant
                  that you have the authority to act on such Provider’s behalf
                  and that you are not using the Services, or otherwise engaging
                  in the activities described in clauses (i) through (iii)
                  above, for the benefit or at the direction, of any person or
                  entity other than such Provider, including yourself.
                </li>
                <li class="my-4">
                  Your Workforce. Each member of your Authorized Workforce shall
                  have and use a unique identifier. You will ensure that no
                  member of your Authorized Workforce uses credentials assigned
                  to another Authorized Workforce member. You may permit your
                  Authorized Workforce to use the Services on your behalf,
                  subject to the terms of this Agreement. You will:
                  <ul>
                    <li class="my-4">
                      require each member of your Authorized Workforce to have
                      unique HealthBook+ credentials, and will provide the legal
                      names of each such member for which you are seeking
                      HealthBook+ credentials;
                    </li>
                    <li class="my-4">
                      train all members of your Authorized Workforce in the
                      requirements of this Agreement and the policies and
                      procedures relating to their access to and use of the
                      Services, and ensure that they comply with such
                      requirements;
                    </li>
                    <li class="my-4">
                      take appropriate disciplinary action against any member of
                      your Authorized Workforce who violates the terms of this
                      Agreement or the applicable HealthBook+ provided policies
                      and procedures for use of the Services;
                    </li>
                    <li class="my-4">
                      ensure that only the person to whom a specific set of
                      HealthBook+ credentials have been assigned accesses the
                      Services with such HealthBook+ credentials; and
                      immediately notify us of the termination of employment of
                      any member of your Authorized Workforce, or of your
                      withdrawal of authorization for any such person to access
                      the Services.
                    </li>
                  </ul>
                </li>
              </ol>
              <p :class="['pt-5 mb-2', $style.subListHeading]">
                <strong> Business Associate Agreement (“BAA”) </strong>
              </p>
              <p>
                For purposes of this Section, terms not defined below or in the
                body of this Agreement (whether or not capitalized) have the
                definitions given to them in the Health Insurance Portability
                and Accountability Act of 1996, the Health Information
                Technology for Economic and Clinical Health Act of 2009, and all
                regulations promulgated thereunder, including the Privacy Rule
                and the Security Rule, as amended (collectively, “HIPAA”).
                “Protected Health Information” or “PHI” shall have the same
                meaning as the term “protected health information” in HIPAA but
                shall be limited to the information that we create, receive,
                maintain, or transmit on your behalf. This Business Associate
                Agreement shall be applicable only in the event and to the
                extent that HealthBook+ meets, with respect to you, the
                definition of a Business Associate set forth at 45 C.F.R.
                §160.103, or applicable successor provisions.
              </p>
              <p>
                HealthBook+’s Use and Disclosure of Your PHI<br />
                We may use and disclose your PHI as follows:
              </p>
              <ol type="1">
                <li class="my-4">
                  To provide the Services to you. Part of the Services includes
                  the storage of your PHI in order to: (i) make it available to
                  you and your Workforce for any legal purpose, including
                  treatment, payment and health care operations; (ii) to
                  facilitate the sharing of PHI among users and other parties
                  with whom you or your Workforce member elect to share such
                  information, and (iii) to make information available to your
                  patients through HealthBook+. You may make PHI accessible to
                  other users of the Services, other individuals and entities,
                  or your patients through the Services for these purposes.
                  Specifically:

                  <ol type="a">
                    <li class="my-4"
                      >We will permit unrestricted access to your PHI to you and
                      your Authorized Workforce. You are responsible for
                      ensuring that your use of the PHI is consistent with HIPAA
                      and other applicable laws.</li
                    >
                    <li class="my-4"
                      >We will permit access to PHI to your patients to whom you
                      have enabled access through HealthBook+.</li
                    >
                    <li class="my-4"
                      >We will permit access to PHI to other health care
                      providers who have an active treatment relationship with
                      your patients and who need access to such PHI for the
                      purposes of providing treatment, as such term is defined
                      by HIPAA, to such patients.</li
                    >
                    <li class="my-4"
                      >We will permit access to your PHI to other covered
                      entities, and their business associates, to whom you have
                      expressly consented to provide access to the Services and
                      who have otherwise agreed to integrate with our Services.
                      You acknowledge that once we have granted access rights to
                      another provider or covered entity (or their respective
                      business associates), we have no control over the uses and
                      disclosures that such person or entity makes of your PHI,
                      and the recipient may be subject to its own legal and
                      regulatory obligations (including HIPAA) to retain such
                      information and make such information available to
                      patients, governmental authorities and others as required
                      by applicable law or regulations.</li
                    >
                    <li class="my-4"
                      >We may use your PHI and Directory Information to contact
                      your patients on your behalf for any purpose for which you
                      would be permitted to contact them, including:
                      <ol type="i">
                        <li class="my-4"
                          >For treatment and health care operations messages,
                          including sending appointment notifications (such as
                          appointment requests, confirmations, reminder,
                          cancellations and the like) and messages about
                          currently prescribed medications (including refill
                          reminders), and post-visit treatment satisfaction
                          surveys, invitations and administrative messages
                          concerning HealthBook+ access, and the like;</li
                        >
                        <li class="my-4"
                          >With your consent, to request an authorization on
                          your behalf from your patients to use or disclose PHI
                          for any purpose for which use or disclosure may be
                          made with an appropriate authorization, including
                          marketing and research purposes. You agree that we may
                          also use and disclosure your patients' PHI as
                          permitted by such authorization; and</li
                        >
                        <li class="my-4"
                          >To provide information about health-related products
                          or services that you provide, or that we provide on
                          your behalf as your business associate.</li
                        >
                      </ol>
                    </li>
                    <li class="my-4"
                      >From time to time, and to the extent permitted by HIPAA
                      and other applicable law, we may incorporate information
                      we receive from your authorized service providers, our
                      third party partners, or covered entities (and their
                      business associates) who are providing or paying for
                      medical services for one or more of your patients, into
                      the Services we provide to you. Such information may
                      include, without limitation, clinical information such as
                      lab results, imaging results, eligibility information,
                      prior authorizations, and prescription history; and shall,
                      upon incorporation into the Services, be treated as your
                      PHI for all purposes hereunder. You hereby authorize us to
                      request and receive such information on your behalf from
                      such authorized service providers or our third-party
                      partners.</li
                    >
                    <li class="my-4"
                      >We may use or disclose your PHI for other purposes, as
                      from time to time described in our Policies and
                      Procedures; provided that we will not make or permit any
                      such use or disclosure that would violate applicable law
                      or regulation if made by you or your business
                      associate.</li
                    >
                  </ol>
                </li>
                <li class="my-4">
                  To carry out our legal responsibilities or for our proper
                  management and, provided that any such disclosures are either
                  (1) Required by Law, or (2) we obtain reasonable assurances
                  from the person to whom the information is disclosed that it
                  will remain confidential and used or further disclosed only as
                  Required by Law or for the purpose for which it was disclosed
                  to the person, and the person notifies us of any instances of
                  which it becomes aware in which the confidentiality of the
                  information has been breached.
                </li>
                <li class="my-4">
                  To provide Data Aggregation services to you as permitted by
                  the Privacy Rule. This will include, for example, using your
                  PHI to prepare analyses and reports such as activity or
                  quality-metrics reports
                </li>
                <li class="my-4">
                  To create de-identified information in accordance with the
                  requirements outlined in the Privacy Rule. Data that has been
                  de-identified will no longer be subject to the terms of this
                  Agreement and you hereby transfer and assign to us all right,
                  title and interest in and to all de-identified information
                  that we make from your PHI. You agree that we may use,
                  disclose, market, license and sell such de-identified
                  information for any purpose without restriction, and that you
                  have no interest in such information, or in the proceeds of
                  any sale, license, or other commercialization thereof. You
                  acknowledge that the rights conferred by this Section are the
                  principal consideration for the provision of the Services,
                  without which we would not enter into this BAA.
                </li>
                <li class="my-4">
                  To the extent permitted by the Privacy Rule, we may create
                  Limited Data Sets from your PHI, and disclose them for
                  purposes of research, public health, and health care
                  operations pursuant to a valid Data Use Agreement. You hereby
                  authorize us to enter into Data Use Agreements on your behalf
                  for the use of the Limited Data Sets, in accordance with HIPAA
                  and other applicable law.
                </li>
              </ol>
              <p class="mt-4">
                In creating, receiving, maintaining, or transmitting PHI on your
                behalf in accordance with this Agreement, we will:
              </p>
              <ol type="1">
                <li class="my-4"
                  >Not use or disclose PHI except as permitted or required by
                  this Agreement or as required by law (as such term is defined
                  in 45 CFR § 164.103);</li
                >
                <li class="my-4"
                  >Use appropriate safeguards and comply, where applicable, with
                  the requirements of the Security Rule with respect to
                  electronic PHI to prevent the use or disclosure of such
                  information in a manner inconsistent with the provisions of
                  this Agreement;</li
                >
                <li class="my-4"
                  >Report to you any use or disclosure of PHI not provided for
                  by this Agreement of which we become aware, including any
                  Breach of Unsecured PHI as required by 45 CFR § 164.410, and
                  any Security Incident of which we become aware; however, this
                  Agreement serves as our notice to you that attempted but
                  unsuccessful Security Incidents, such as pings and other
                  broadcast attacks on our firewall, port scans, unsuccessful
                  log-on attempts, denials of service and any combination of the
                  above, regularly occur and that no further notice will be made
                  by us unless there has been a successful Security
                  Incident;</li
                >
                <li class="my-4"
                  >In accordance with 45 CFR §§ 164.502(e)(1)(ii) and
                  164.308(b)(2), as applicable, ensure that any subcontractors
                  that create, receive, maintain or transmit PHI on our behalf
                  agree to substantially the same restrictions and conditions
                  that apply to us with respect to such PHI (it being
                  understood, for the avoidance of doubt, that other users of
                  the Services are not our subcontractors);</li
                >
                <li class="my-4"
                  >Make available to you your PHI in furtherance of your
                  obligations under 45 CFR § 164.524;
                </li>
                <li class="my-4"
                  >Make available to you your PHI in furtherance of your
                  obligations to amend and incorporate any amendments to such
                  information in accordance with 45 CFR § 164.526;</li
                >
                <li class="my-4"
                  >Document and make available to your information necessary for
                  you to provide an accounting of disclosures in accordance with
                  45 CFR § 164.528;</li
                >
                <li class="my-4"
                  >To the extent that we are to carry out your obligations under
                  the Privacy Rule, comply with the requirements of the Privacy
                  Rule that apply to you in the performance of such
                  obligations;</li
                >
                <li class="my-4"
                  >Make our internal practices, books, and records relating to
                  the use and disclosure of PHI received from, or created or
                  received by us on your behalf, available to the Secretary of
                  the United States Department of Health and Human Services for
                  purposes of determining your compliance with the Privacy Rule;
                  and</li
                >
                <li class="my-4"
                  >At termination of this Agreement we will provide you with a
                  copy of your PHI in an electronic form that is accessible
                  through commercially available hardware and software. You may
                  have to purchase such hardware and software from third parties
                  in order to access your PHI, and you may have to configure
                  your systems in order to use your PHI in your practice. Upon
                  termination we will, if feasible, return or destroy all PHI
                  received from, or created or received by us on your behalf
                  that we still maintain in any form, and retain no copies of
                  such information; or, if such return or destruction is not
                  feasible (whether for technical, legal, regulatory or
                  operational reasons), extend the protections of this Agreement
                  to the information and limit further uses and disclosures to
                  those purposes that make the return or destruction of the
                  information infeasible.
                </li>
              </ol>
              <p :class="['pt-5 mb-1', $style.subListHeading]">
                <strong> Your Responsibilities with Respect to PHI </strong>
              </p>
              <p>
                You are solely responsible for affording individuals their
                rights with respect to relevant portions of PHI, such as the
                rights of access, amendment, and accounting of disclosures. You
                will not undertake to afford an individual any rights with
                respect to information in the Services other than your PHI.
              </p>
              <p>
                We apply the standards of the Privacy Rule in permitting access
                to the Services. You acknowledge that other federal and state
                laws impose additional restrictions on the use and disclosure of
                certain types of health information, or health information
                pertaining to certain classes of individuals. You agree that you
                are solely responsible for ensuring that your PHI may properly
                be disclosed for the purposes set forth in this Agreement,
                subject to the restrictions of the Privacy Rule and applicable
                law, including those laws that may be more restrictive than the
                Privacy Rule. In particular, you will: (i) not make available to
                other users through the Services any information in violation of
                any restriction on use or disclosure (whether arising from your
                agreement with such users or under law); (ii) obtain all
                necessary consents, authorizations, or releases from individuals
                required for making their health information available through
                the Services for the purposes set forth herein; (iii) include
                such statements (if any) in your notice of privacy practices as
                may be required in connection with your use of the Services; and
                (iv) not place in the Services any information that you know or
                have reason to believe is false or materially inaccurate.
              </p>
              <p>
                You shall notify us of: (i) any limitations(s) in your notice of
                privacy practices in accordance with 45 CFR § 164.520 to the
                extent that such changes may affect our use or disclosure of
                Protected Health Information; (ii) any changes in, or revocation
                of, permission by Individual to use or disclose Protected Health
                Information, to the extent that such changes may affect our use
                or disclosure of Protected Health Information; and (iii) any
                restriction to the use or disclosure of Protected Health
                Information that you have agreed to in accordance with 45 CFR §
                164.522, to the extent that such restriction may affect our use
                or disclosure of Protected Health Information.
              </p>
              <p>
                You agree that you will not request that we use or disclose
                Protected Health Information in any manner that would not be
                permissible under the Privacy Rule if done by you.
              </p>
              <p>
                You agree to comply with those security obligations identified
                in the Agreement, and to implement, purchase, or maintain
                appropriate safeguards as required for you to comply with the
                Security and Privacy rules as applicable to you.
              </p>
            </li>
          </ol>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

.termsPageContainer {
  max-width: 1200px !important;
  padding: 20px 30px 20px 120px !important;
  margin: 0 !important;
}

.termsPageContainer .customOrderList ol {
  padding: 0;
  margin: 0;
  list-style-type: none;
  counter-reset: item;
}

.termsPageContainer .customOrderList ol > li {
  display: table;
  margin-bottom: 0.6em;
  counter-increment: item;
}

.termsPageContainer .customOrderList ol > li::before {
  display: table-cell;
  padding-right: 0.6em;
  content: counters(item, '.') '. ';
}

.termsPageContainer .customOrderList li ol > li {
  margin: 0;
}

.termsPageContainer .customOrderList li ol > li::before {
  content: counters(item, '.') ' ';
}

.pageHeading {
  margin: 30px 0;
  font-weight: 700;
}

.pageText {
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: justify;
}

.listHeading {
  color: #082787;
}

.subListHeading {
  color: #3193fc;
}

@media screen and (max-width: 1200px) {
  .termsPageContainer {
    padding-left: 28px !important;
  }
}

@media screen and (max-width: 450px) {
  .termsPageContainer {
    padding-left: 20px !important;
  }
}
</style>
